import { ArrowDown, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { TopographicLines } from "./TopographicLines";

export function Hero() {
  const { messages } = useI18n();

  return (
    <section className="hero" aria-labelledby="hero-title">
      <TopographicLines className="hero__contours" />
      <div className="hero__inner shell">
        <div className="hero__copy">
          <div className="mineral-scale" aria-hidden="true">
            <span>Ca</span>
            <span>Mg</span>
            <span>Na</span>
            <span>HCO₃</span>
          </div>
          <div>
            <h1 id="hero-title">{messages.hero.title}</h1>
            <p className="hero__lede">{messages.hero.lede}</p>
            <div className="hero__actions">
              <Link className="button" to="/#interest">
                {messages.hero.primaryAction}
                <ArrowRight
                  className="directional-icon"
                  size={18}
                  aria-hidden="true"
                />
              </Link>
              <Link className="text-link" to="/#water">
                {messages.hero.secondaryAction}
                <ArrowDown size={17} aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
        <figure className="hero__media">
          <img
            src="/assets/images/borsec-carpathians-dubai.jpg"
            alt={messages.hero.imageAlt}
            width="1536"
            height="1024"
            fetchPriority="high"
          />
          <figcaption>{messages.hero.imageCaption}</figcaption>
        </figure>
      </div>
      <div className="hero__disclosure shell">
        <span>{messages.hero.independent}</span>
        <span aria-hidden="true">·</span>
        <span>{messages.hero.disclosure}</span>
      </div>
    </section>
  );
}
